module.exports = __webpack_public_path__ + "static/media/CloseX.5528ebcf.svg";